import {
  API_RESPONSE_ERROR,
  API_RESPONSE_SUCCESS,
  CANCEL_PROPOSAL,
  CHANGE_STATUS,
  REACTIVE_PROPOSAL,
  CHECK_CPF_PROPOSAL,
  CREATE_PROPOSAL,
  DELETE_PROPOSAL,
  GET_PROPOSAL,
  GET_PROPOSAL_ASSOCIATES,
  GET_PROPOSAL_BY_ID,
  UPDATE_PROPOSAL,
} from './actionType';

const INIT_STATE = {
  proposals: null,
  proposalId: {},
  proposalsAssociates: null,
  error: {},
  success: null,
  loadingByAssociates: true,
};

const Proposal = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PROPOSAL:
          return {
            ...state,
            proposals: action.payload.data,
            success: null,
            error: {},
            proposalId: {},
          };
        case CREATE_PROPOSAL:
          return {
            ...state,
            success: 'Successfully created proposal',
            error: {},
          };
        case UPDATE_PROPOSAL:
          return {
            ...state,
            success: 'Successfully updated proposal',
            error: {},
          };
        case DELETE_PROPOSAL:
          return {
            ...state,
            success: 'Successfully delete proposal',
            error: {},
          };
        case CHECK_CPF_PROPOSAL: {
          return {
            ...state,
            success: 'Successfully check proposal',
            proposals: [],
            error: {},
          };
        }
        case GET_PROPOSAL_BY_ID: {
          return {
            ...state,
            success: 'Successfully get proposal by CPF/CNPJ',
            error: {},
            proposalId: action.payload.data,
          };
        }
        case GET_PROPOSAL_ASSOCIATES: {
          return {
            ...state,
            success: null,
            error: {},
            proposalsAssociates: action.payload.data,
            loadingByAssociates: false,
          };
        }
        case CANCEL_PROPOSAL:
          return {
            ...state,
            success: 'Successfully canceled proposal',
            error: {},
          };
        case CHANGE_STATUS:
          return {
            ...state,
            success: 'Successfully status changed proposal',
            error: {},
          };
        case REACTIVE_PROPOSAL:
          return {
            ...state,
            success: 'Successfully status reactivated proposal',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_PROPOSAL:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case CREATE_PROPOSAL:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case UPDATE_PROPOSAL:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case DELETE_PROPOSAL:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case CHECK_CPF_PROPOSAL: {
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        }
        case GET_PROPOSAL_BY_ID: {
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        }
        case GET_PROPOSAL_ASSOCIATES: {
          return {
            ...state,
            success: '',
            error: action.payload.error,
            loadingByAssociates: false,
          };
        }
        case CANCEL_PROPOSAL:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case CHANGE_STATUS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case REACTIVE_PROPOSAL:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_PROPOSAL: {
      return {
        ...state,
      };
    }
    case CREATE_PROPOSAL: {
      return {
        ...state,
      };
    }
    case UPDATE_PROPOSAL: {
      return {
        ...state,
      };
    }
    case DELETE_PROPOSAL: {
      return {
        ...state,
      };
    }
    case CHECK_CPF_PROPOSAL: {
      return {
        ...state,
      };
    }
    case GET_PROPOSAL_BY_ID: {
      return {
        ...state,
        proposalId: {},
      };
    }
    case GET_PROPOSAL_ASSOCIATES: {
      return {
        ...state,
        loadingByAssociates: true,
      };
    }
    case CANCEL_PROPOSAL: {
      return {
        ...state,
      };
    }
    case CHANGE_STATUS:
      return {
        ...state,
      };
    case REACTIVE_PROPOSAL:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};

export default Proposal;
